import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TermosServicosComponent } from './termos-servicos/termos-servicos.component';
import { PoliticaPrivacidadeComponent } from './politica-privacidade/politica-privacidade.component';
import { TermosPoliticasComponent } from './termos-politicas.component';

const routes: Routes = [
  {path: 'termos-servicos', component: TermosServicosComponent},
  {path: 'politica-privacidade', component: PoliticaPrivacidadeComponent},
  {path: '**', redirectTo: 'termos-servicos', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TermosPoliticasRoutingModule { }
